import { DATE_PRESETS } from "@/constants/date-presets"
import { endOfDay, isValid, parseISO } from "date-fns"

import { DateRangePanel } from "@/components/date-range/DateRangePanel"
import type { CollectionFilterValue } from "@/hooks/useCollectionFilters"

function readDate(value: string | undefined, end: boolean) {
  if (!value) {
    return null
  }
  const date = parseISO(value)
  if (!isValid(date)) {
    return null
  }
  return end && /^\d{4}-\d{2}-\d{2}$/.test(value) ? endOfDay(date) : date
}

export function CollectionDateFilter({
  value,
  onChange,
}: {
  value: CollectionFilterValue
  onChange: (value: CollectionFilterValue) => void
}) {
  return (
    <DateRangePanel
      value={{
        start: readDate(value.min, false),
        end: readDate(value.max, true),
      }}
      onRangeChange={({ start, end }) =>
        onChange({ min: start?.toISOString(), max: end?.toISOString() })
      }
      presets={DATE_PRESETS}
      onClear={() => onChange({})}
    />
  )
}
